import { AD_TYPE_OPTIONS, AD_TYPES_BY_VERTICAL } from "@/sell/models/AdTypes";
import { useFormContext } from "react-hook-form";
import { AdEditModel } from "@/sell/models/AdEditModel";
import { AD_PRICE_TYPE_OPTIONS } from "@/sell/models/AdPriceTypes";
import ControlledAspectAutocomplete from "../../form/ControlledAutocompleteField";
import Row from "../../Row";
import ControlledPriceField from "../../form/ControlledPriceField";

function AdTypeField({ name }: { name: string }) {
  const { watch } = useFormContext<AdEditModel>();
  const vertical = watch("vertical");

  const adTypeOptions = AD_TYPE_OPTIONS.filter((x) =>
    AD_TYPES_BY_VERTICAL[vertical]?.includes(x.value),
  );

  if (adTypeOptions.length > 1) {
    return (
      <ControlledAspectAutocomplete
        name={name}
        label="Type"
        options={adTypeOptions}
      />
    );
  }
}

function AdPriceField() {
  const { watch } = useFormContext<AdEditModel>();
  const priceType = watch("details.priceType");

  const priceTypeOption = AD_PRICE_TYPE_OPTIONS.find(
    (option) => option.value === priceType,
  );

  if (priceTypeOption?.hidePrice) {
    return null;
  }

  return (
    <ControlledPriceField
      name="details.price"
      label="Price"
      countryName="contact.country"
      currencyName="details.priceCurrency"
    />
  );
}

export default function AdPricingDetails() {
  return (
    <Row>
      <AdTypeField name="details.type" />
      <AdPriceField />
      <ControlledAspectAutocomplete
        name="details.priceType"
        label="Price Type"
        options={AD_PRICE_TYPE_OPTIONS}
      />
    </Row>
  );
}
